import React from "react";



const GetLoader = () => {
    // const [userData,setUserData] = useState({});
    return(
        <span>Loading <i className="fa fa-spinner fa-spin"></i></span>
        // <>{userData?.dealerInfo?.is_kyc_active == false && userData?.dealerInfo?.is_kyc_submitted == false  &&  !userData?.dealerInfo?.is_kyc_rejected ? "" : <span>Loading <i className="fa fa-spinner fa-spin"></i></span>}</>
        
    )
}

export default GetLoader;